import React, { useState, useMemo } from 'react';
import AllMemberLevelStyled from './AllMemberLevelStyled';
import { Button, useTheme } from '@material-ui/core';
import CouponModal from '../../coupon_modal/index';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { Switch } from 'antd';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'dva';
import ChooseCoupon from '../member_level/choose_coupon/index';
import { useIntl } from 'umi';

export default (props) => {
  const { control } = useForm();
  const theme = useTheme();
  const dispatch = useDispatch();
  const {
    // memberLevelData: memberLevelList,
    // setMemberLevel,
    opt,
    id,
    ids,
    // allLevelMember=[],
    allLevelData,
    setAllLevelData = () => {},
    setIsSave,
  } = props;
  const intl = useIntl();
  const { formatMessage } = intl;

  const [dialogStatus, setDialogStatus] = useState(false);
  const [couponOpen, setCouponOpen] = useState(false);
  // 展示优惠券列表的弹窗

  // const itemCoupons=useSelector((state) => state.sceneMarketing?.coupons);
  const allCoupons = useSelector((state) => state.sceneMarketing?.allCoupons);
  // const couponList =useSelector((state) => state.sceneMarketing?.couponsList)||[];

  const couponIds = useSelector((state) => state.sceneMarketing?.couponIds);

  // 每个数组里的coupon
  const [couponId, setCouponId] = useState();
  const [coupons, setCoupons] = useState([]);
  const [type, setType] = useState();
  const [modify, setModify] = useState({});
  const [allMember, setAllMember] = useState([
    {
      code: 0,
      name: '-',
      discountPercent: '',
      pointMultiply: '',
      pointAdd: '',
      coupons: '[]',
      status: 1,
      couponNum: 0,
      level: null,
    },
  ]);

  const newAllMemberLevel = useMemo(() => {
    if (allLevelData?.length > 0 && allLevelData?.length < 4) {
      let newArr = allLevelData;
      newArr.forEach((memberLv) => {
        let num = 0;
        if (memberLv?.coupons !== null && Array.isArray(memberLv?.coupons)) {
          for (let i = 0; i < memberLv?.coupons?.length; i++) {
            num =
              Number(num || 0) + Number(memberLv?.coupons[i]?.couponCode || 0);
          }
          memberLv['couponNum'] = num;
          memberLv.coupons &&
            memberLv.coupons.forEach((i) => {
              if (!i.id) {
                i['id'] = i.couponId;
              }
            });
        } else {
          memberLv['couponNum'] = 0;
        }
      });
      return newArr;
    }
  }, [allLevelData]);

  const handleChangeStatus = (e, index) => {
    if (id && newAllMemberLevel) {
      newAllMemberLevel[index].status = e;
      setAllLevelData(newAllMemberLevel);
    } else {
      const arr = [...allMember];
      arr[index].status = e;
      setAllLevelData(arr);
    }
  };

  // 得到张数
  useMemo(() => {
    if (couponIds === 0) {
      let num = 0;
      for (let i = 0; i < allCoupons[couponIds]?.length; i++) {
        num =
          Number(num || 0) + Number(allCoupons[couponIds][i]?.couponCode || 0);
      }
      if (id && newAllMemberLevel?.length > 0) {
        const arr = [...newAllMemberLevel];
        arr[couponIds]['couponNum'] = num;
        const data = arr[couponIds];
        data['coupons'] = allCoupons[couponIds];
        setAllLevelData(arr);
      } else {
        const arr = [...allMember];
        arr[couponIds]['couponNum'] = num;
        const data = arr[couponIds];
        data['coupons'] = allCoupons[couponIds];
        setAllLevelData(arr);
        setAllMember(arr);
        console.log({ newAllMemberLevel, allMember, couponIds, arr });
      }
    }
  }, [couponIds, couponId, modify, id]);

  const handleSetting = (item) => {
    // 点击打开modal
    // 存到model里
    setCoupons(item?.coupons || []);
    const arr = [];

    if (item?.coupons?.length > 0 && Array.isArray(item?.coupons)) {
      setDialogStatus(true);
    } else {
      setCouponOpen(true);
      // seIsHasCoupons(false);
    }
    dispatch({
      type: 'sceneMarketing/saveCouponsList',
      payload: {
        value: item?.coupons || arr,
      },
    });
    const code = item.level ? item.level : item.code || 0;
    setCouponId(code);
    dispatch({
      type: 'sceneMarketing/saveItemCoupons',
      payload: {
        value: {
          id: code,
          coupons: item?.coupons || arr,
        },
      },
    });
    dispatch({
      type: 'sceneMarketing/saveCouponsId',
      payload: {
        value: code,
      },
    });
    setType(item.level === null ? 'allLevel' : 'memberLevel');
  };

  const showLevelData = (data) => {
    return data?.map((item, index) => (
      <div className="level-content">
        <div
          className={
            item?.name === '-' || item.level === null
              ? 'all-level'
              : 'forth-level'
          }
        >
          {item.name ? item.name : item.level}
        </div>
        <div>
          <SvgIconML
            name={'coupon'}
            className={item?.couponNum > 0 ? 'coupon' : 'noCoupon'}
          ></SvgIconML>
          <span>
            {item?.couponNum || 0}
            {/* 张 */}
            {formatMessage({ id: 'comm.chart.lbl.10' })}
          </span>
          {/* 点击设置打开弹窗 */}
          <Button
            onClick={() => handleSetting(item)}
            disabled={opt === 'detail'}
            className={
              item?.couponNum > 0
                ? 'coupon-settings coupons'
                : 'coupon-settings noCoupons'
            }
          >
            {item?.couponNum > 0
              ? formatMessage({ id: 'marketing.scene.holiday.c02.txt02' })
              : formatMessage({ id: 'marketing.scene.holiday.c02.txt01' })}
          </Button>
        </div>
        <Controller
          render={(pr) => (
            <Switch
              checkedChildren={formatMessage({
                id: 'marketing.scene.holiday.c02.txt03',
              })}
              unCheckedChildren={formatMessage({
                id: 'marketing.scene.holiday.c02.txt04',
              })}
              checked={Boolean(item.status)}
              // defaultChecked={Boolean(item.status)}
              // onChange={(e) => handleChangeStatus(e, index)}
              onClick={(e) => {
                handleChangeStatus(e, index);
                return pr.onChange(e);
              }}
              disabled={opt === 'detail'}
            />
          )}
          control={control}
          name="point"
        ></Controller>
      </div>
    ));
  };

  return (
    <AllMemberLevelStyled theme={theme}>
      {id && newAllMemberLevel
        ? showLevelData(newAllMemberLevel)
        : showLevelData(allMember)}
      <CouponModal
        couponType={type}
        dialogStatus={dialogStatus}
        setDialogStatus={setDialogStatus}
        coupons={coupons}
        setCoupons={setCoupons}
        // 每条数据的唯一标志
        couponId={couponIds}
        ids={ids}
        editId={id}
        // modify, setModi//fy
        setModify={setModify}
        setIsSave={setIsSave}
      ></CouponModal>
      {/* 新建时弹出框 */}
      <ChooseCoupon
        dialogStatus={couponOpen}
        setDialogStatus={setCouponOpen}
        couponId={couponIds}
        setCoupons={setCoupons}
        setModify={setModify}
      ></ChooseCoupon>
    </AllMemberLevelStyled>
  );
};
